import React from 'react'
import '@loyal_template/bannersVSA.css'

class BannersVSA extends React.Component {
  render () {
    return (
      <div className='container'>
        <div className='row py-1'>
          <div className='col-12 col-md-4 mx-auto mx-md-0 py-1'>
            <a href={process.env.REACT_APP_BANNER_DR_CONSULTA} title='Ir para Dr. Consulta'>
              <div className='drConsulta mx-auto' />
            </a>
          </div>
          <div className='col-12 col-md-4 mx-auto mx-md-0 py-1'>
            <a href={process.env.REACT_APP_BANNER_SMILES} title='Ir para Smiles'>
              <div className='smiles mx-auto' />
            </a>
          </div>
          <div className='col-12 col-md-4 mx-auto mx-md-0 py-1'>
            <a href={process.env.REACT_APP_BANNER_VALE_VIAGEM} title='Ir para Shell Box'>
              <div className='valeViagem mx-auto' />
            </a>
          </div>
        </div>
      </div>
    )
  }
}
export default BannersVSA



// WEBPACK FOOTER //
// ./src/features/Services/BannersVSA/BannersVSA.js